import { Injectable } from '@angular/core';

import { Building } from '../models';
import { AppState } from '../app-state';

import { RxDocument } from 'rxdb';
import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { buildingPullQueryBuilder, buildingSchema } from '../schema/building-schema';
import { RestClient } from './rest-client';
import { HttpClient } from '@angular/common/http';

class BuildingRestClient extends RestClient<Building> {
  constructor(http: HttpClient, appState : AppState ) {
      super(http, 'building', appState)
  }
}

export type BuildingDoc = RxDocument<Building, {}>;

@Injectable({ providedIn: "root" })
export class BuildingService extends TestbedRxdbGraphQlCollectionService<
  Building,
  BuildingDoc
> {
  restClient : BuildingRestClient
  constructor(
    appState: AppState,
    authService: AuthenticationService,
    rxdbState: TestbedRxdbState,
    http: HttpClient
  ) {
    super("building", buildingSchema, appState,rxdbState, authService);
        this.syncConfig = { 
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.building.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: buildingPullQueryBuilder(),
            graphQLSubscription: 
            `subscription{
                buildingUpdated{
                    buildings{
                        id
                    }
                }
            }`
        }
    this.restClient = new BuildingRestClient(http,appState)
  }

  update(building: Building) {
    console.log("Updating building " + JSON.stringify(this.restClient.urlPath));
    return this.restClient.http.patch(this.restClient.urlPath, building, { observe: 'response' });
  }
}